<template>
  <div>
    <section class="content">
      <div class="row">
           <div class="box box-info">
              <div class="box-body fondo">
                  <div class="row">
                      <div class="col-md-12">
                          <div class="info-box fondo">
                            <ul class="timeline">
                                      <!-- timeline time label -->
                                        <li class="time-label" >
                                          <span class="bg-red">Datos personales</span>
                                        </li>
                                        <li>
                                          <i class="fa fa-user bg-red"></i>
                                            <div class="timeline-item col-md-10  ">
                                              <h3 class="timeline-header control-label bg-danger">Nombre y apellido</h3>
                                              <div class="timeline-body ">
                                                <div class="col-md-12 ">
                                                    <div class="col-md-12 ">
                                                      <textarea class="form-control " type="text" rows="1" name="name" id="name" v-on:change="nameChange" v-model="user.name" required/></textarea>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="timeline-footer text-center">
                                                <br>
                                              </div>
                                            </div>
                                        </li>
                                        <li>
                                          <i class="fa fa-envelope bg-red"></i>
                                            <div class="timeline-item col-md-10  ">
                                              <h3 class="timeline-header control-label bg-danger">Correo electrónico</h3>
                                              <div class="timeline-body ">
                                                <div class="col-md-12 ">
                                                    <div class="col-md-12 ">
                                                      {{user.email}}
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="timeline-footer text-center">
                                                <br>
                                              </div>
                                            </div>
                                        </li>
                                        <li class="time-label" v-if="user.company">
                                          <span class="bg-red">Datos de la compañia</span>
                                        </li>
                                        <li v-if="user.company">
                                            <i class="fa fa-building bg-red"></i>
                                            <div class="timeline-item col-md-10 bg-danger">
                                              <h3 class="timeline-header control-label bg-danger">Datos de la compañia</h3>
                                              <div class="timeline-body ">
                                                <div class="col-md-12 ">
                                                  <div class="col-md-12" style="margin-bottom:15px">
                                                      <el-button v-for="country in availableCountries"
                                                        :key="country.codCountry"
                                                        type="danger" 
                                                        @click="currentCountry = country.codCountry" 
                                                        :disabled="idFIT != countryData[country.codCountry].idFIT" >
                                                          {{countryData[country.codCountry].name}}
                                                      </el-button>
                                                      <!-- <el-button type="danger" @click="currentCountry = 'AR'" :disabled="idFIT != 1">Argentina</el-button>
                                                      <el-button type="danger" @click="currentCountry = 'PE'" :disabled="idFIT != 2">Perú</el-button> -->
                                                    </div>
                                                    <div class="col-md-12 " style="margin-bottom: 15px">
                                                      <el-button v-if="currentCountry.length > 0" type="primary" :disabled="currentCountry.length <= 0" @click="viewCompanyData(0)">Ver datos generales</el-button>
                                                      <!--ARGENTINA Y DEMÁS-->
                                                      <el-button v-if="currentCountry !== 'PE' && currentCountry.length > 0" type="primary" :disabled="currentCountry.length <= 0" @click="viewCompanyData(1)">Ver datos bancarios</el-button>
                                                      <el-button  v-if="currentCountry !== 'PE' && currentCountry.length > 0" type="primary" :disabled="currentCountry.length <= 0" @click="viewCompanyData(2)">Ver datos impositivos</el-button>
                                                      <!--PERU-->
                                                      <el-button  v-if="currentCountry === 'PE'" type="primary" :disabled="currentCountry.length <= 0" @click="viewCompanyData(1)">Ver datos impositivos</el-button>
                                                      <el-button v-if="currentCountry === 'PE'" type="primary" :disabled="currentCountry.length <= 0" @click="viewCompanyData(2)">Ver datos bancarios</el-button>
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                        </li>
                                        <li v-if="user.isProvider">
                                            <i class="fa fa-building bg-blue"></i>
                                            <div class="timeline-item col-md-10">
                                              <h3 class="timeline-header control-label bg-green">Documentación vigente</h3>
                                              <div class="timeline-body ">
                                                <div class="col-md-12 ">
                                                    <div class="col-md-12 ">
                                                        <div v-for="(document, index) in user.documentation" class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                                                          <div class="info-box bg-blue" @click="loadDocument(user.document[index].url)">
                                                            <span class="info-box-icon" style="height: 16vh; width: 16vh">
                                                              <i class="fa fa-book"></i>
                                                            </span>
                                                            <div class="info-box-content">
                                                              <h3>
                                                                <span>{{document.documentName}}</span>
                                                              </h3>
                                                              <h6>
                                                                <span>Fecha de emisión: {{user.document[index].emisionDate}}</span><br>
                                                                <span>Fecha de alta: {{user.document[index].date}}</span>
                                                              </h6>
                                                            </div>
                                                          </div>
                                                        </div>

                                                    </div>
                                                </div>
                                              </div>
                                            </div>

                                        </li>

                            </ul>

                          </div>

                       </div>

                  </div>


              </div>
          </div>



      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="success" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-green"><i class="ion ion-android-checkmark-circle"></i></span>
                <div class="info-box-content">

                  <span class="info-box-info">{{success}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import Vue from 'vue'
import api from '../../api'
import {timeline} from '../../demo'
import { mapState } from 'vuex'
import ElementUI from 'element-ui'

Vue.use(ElementUI)

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'ChangePsw',
      loading: '',
      comment: '',
      response: null,
      success: null,
      idUser: this.$store.state.user.idUser,
      address: '',
      billingAddress: '',
      comments: '',
      currentCountry: '',
      availableCountries: [],
      countryData: {
        AR: {name: 'Argentina', idFIT: 1},
        PE: {name: 'Perú', idFIT: 2}
      }
    }
  },
  computed: {
    datetime () {
      return new Date()
    },
    ...mapState([
      'userInfo', 'user'
    ]),
    idFIT () {
      return this.user.company.idFIT
    },
    timeline () {
      return timeline
    }
    // bussinesdata () {
      // var datos = {cuit: 369852147, address: 'Mi Direccion 1234', billingAddress: 'Mi otra dirección 4567'}
      // return datos
    // }
  },
  beforeMount () {
    this.address = this.user.company.address
    this.billingAddress = this.user.company.billingAddress
    this.comments = this.user.company.comments
    api.request('get', 'api/checkParam?id=SUN-001')
      .then(response => {
        var data = response.data
        console.log('SUN-001', data)
        this.availableCountries = data
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    viewCompanyData (step) {
      this.$router.push('/companyData/' + this.user.company.idCompany + '/' + step + '/' + this.currentCountry)
    },
    loadDocument (url) {
      let win = window.open(url, '_blank')
      win.focus()
    },
    nameChange (row) {
      api.request('post', 'api/generic/user/' + this.idUser, JSON.stringify(this.user))
      .then(response => {
        this.$store.commit('SET_USER', this.user)
        localStorage.setItem('user', JSON.stringify(this.user))
      })
        .catch(error => {
          console.log(error)
        })
    },
    companyChange (row) {
      this.user.company.address = this.address
      this.user.company.billingAddress = this.billingAddress
      this.user.company.comments = this.comments
      api.request('post', 'api/generic/company/' + this.user.company.idCompany, JSON.stringify(this.user.company))
      .then(response => {
        this.$message({
          type: 'success',
          message: 'Se han guardado los datos'
        })
        localStorage.setItem('user', JSON.stringify(this.user))
      })
        .catch(error => {
          console.log(error)
        })
    },
    sendComment () {
      const {idUser, comment} = this

      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api.request('GET', 'api/sendComment?idUser=' + idUser + '&comment=' + comment)
        .then(response => {
          this.toggleLoading()
          this.invoices = null

          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos suministrados son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'La factura no se encuentra.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              this.success = data.success
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    }
  }
}
</script>

<style>

/*
 * Component: Timeline
 * -------------------
 */
.timeline {
  position: relative;
  margin: 0 0 30px 0;
  padding: 0;
  list-style: none;
}
.timeline:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #ddd;
  left: 31px;
  margin: 0;
  border-radius: 2px;
}
.timeline > li {
  position: relative;
  margin-right: 10px;
  margin-bottom: 15px;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-item {
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-top: 0;
  background: #fff;
  color: #444;
  margin-left: 60px;
  margin-right: 15px;
  padding: 0;
  position: relative;
}
.timeline > li > .timeline-item > .time {
  color: #999;
  float: right;
  padding: 10px;
  font-size: 12px;
}
.timeline > li > .timeline-item > .timeline-header {
  margin: 0;
  color: #555;
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
  font-size: 16px;
  line-height: 1.1;
}
.timeline > li > .timeline-item > .timeline-header > a {
  font-weight: 600;
}
.timeline > li > .timeline-item > .timeline-body,
.timeline > li > .timeline-item > .timeline-footer {
  padding: 10px;
}
.timeline > li > .fa,
.timeline > li > .glyphicon,
.timeline > li > .ion {
  width: 30px;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
  position: absolute;
  color: #666;
  background: #d2d6de;
  border-radius: 50%;
  text-align: center;
  left: 18px;
  top: 0;
}
.timeline > .time-label > span {
  font-weight: 600;
  padding: 5px;
  display: inline-block;
  background-color: #fff;
  border-radius: 4px;
}
.timeline-inverse > li > .timeline-item {
  background: #f0f0f0;
  border: 1px solid #ddd;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.timeline-inverse > li > .timeline-item > .timeline-header {
  border-bottom-color: #ddd;
}
.datetime-picker input {
  height: 4em !important;
}
.row  {
  padding-bottom: 1em;
}

.fondo {
  background-color: #EDEEEE;
}

.fondo_danger {
  background-color: #F0E0D0;
}

.flag:focus {
  border-radius: 3px;
  border: 3px solid #347cc4;
}

.flag{
  margin: 0;
  width: 100%;
  height: auto;
}
.flagButton{
  padding:0;
  height: 100%;
  border: none;
  background-color: transparent;
}


.boton {
  padding: 1em;
}
textarea {
 resize: none;
}




</style>



// WEBPACK FOOTER //
// SelfData.vue?19a70c94